export default __webpack_public_path__ + "media/images/footer-logo-3279d964b0c90df42eb31d90dc42c40c.svg";